<app-navbar-style-one></app-navbar-style-one>

<section class="sign-up-area ptb-100">
    <div class="container-fluid">
        <div class="contact-wrap-form">
            <!-- Step 1: Email Input -->
            <div class="scetion-title text-center row" *ngIf="currentStep === 1">
                <div class="col-12 text-center pt-5">
                    <img src="assets/img/home2/verify.png" alt="Verify Image">
                </div>
                <div class="col-12 text-center">
                    <h1 class="mt-3 signInTitle">Forget password</h1>
                    <p class="mt-5 signInParagraph">Forgot your password? Don’t worry! Just enter the email linked to your account, and we’ll send you instructions to reset your password safely. If you don’t see the email, please check your spam folder.</p>
                </div>
                
                <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
                    <div class="row">
                        <div class="col-12 px-5">
                            <div class="form-group mt-3 px-4 text-start">
                                <label style="color: #003921;" for="email" class="form-label">Email <span class="text-danger">*</span></label>
                                <input class="form-control" type="email" name="email" formControlName="email" placeholder="Enter Your Email">
                                <div *ngIf="resetForm.get('email')?.hasError('required') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Email is required
                                </div>
                                <div *ngIf="resetForm.get('email')?.hasError('email') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Enter a valid email address
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center mb-5">
                            <button class="btn btn-primary px-5" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Send OTP
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Step 2: OTP Verification -->
            <div class="scetion-title text-center row" *ngIf="currentStep === 2">

                <div class="col-12 text-center pt-5">
                    <img src="assets/img/home2/verify.png" alt="Verify Image">
                </div>
                <div class="col-12 text-center">
                    <h1 class="mt-3 signInTitle">Enter Your Code</h1>
                    <p class="mt-5 signInParagraph">We sent a code to <strong>{{resetForm.value.email}}</strong></p>
                </div>                
                <form [formGroup]="otpCodeForm" (ngSubmit)="verifyOtp()">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="otp-input-group">
                                <input type="text" maxlength="1" (input)="moveToNext($event, 1)" #otp1>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 2)" #otp2>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 3)" #otp3>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 4)" #otp4>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 5)" #otp5>
                                <input type="text" maxlength="1" (input)="moveToNext($event, 6)" #otp6>
                            </div>
                            <input type="hidden" formControlName="otp_code">
                            <div *ngIf="otpCodeForm.get('otp_code')?.hasError('required')" class="text-danger text-small text-center mt-2">
                                OTP is required
                            </div>
                        </div>

                        <div class="col-12 text-center mt-4 mb-5">
                            <button class="btn btn-primary me-2 px-4" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Verify
                            </button>
                            <button class="btn btn-outline-secondary px-4" type="button" (click)="resendOtp()" [disabled]="isResending">
                                <span *ngIf="isResending" class="spinner-border spinner-border-sm me-1"></span>
                                Resend OTP
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Step 3: New Password -->
            <div class="scetion-title text-center" *ngIf="currentStep === 3">

                <div class="col-12 text-center pt-5">
                    <img src="assets/img/home2/pass.png" alt="Password Image">
                </div>
                <div class="col-12 text-center">
                    <h1 class="mt-3 signInTitle">Set New Password</h1>
                    <p class="mt-5 signInParagraph">Your new password must be different from previous used passwords.</p>
                </div>                 
                <form class="px-4" [formGroup]="updatePasswordForm" (ngSubmit)="updatePassword()">
                    <div class="row px-5">
                        <div class="col-12 text-start">
                            <div class="form-group">
                                <label>New Password <span class="text-danger">*</span></label>
                                <input class="form-control" type="password" formControlName="password" placeholder="Enter new password">
                                <div *ngIf="updatePasswordForm.get('password')?.hasError('required') && updatePasswordForm.get('password')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Password is required
                                </div>
                                <div *ngIf="updatePasswordForm.get('password')?.hasError('minlength') && updatePasswordForm.get('password')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Password must be at least 8 characters
                                </div>
                            </div>
                        </div>

                        <div class="col-12 mt-3 text-start">
                            <div class="form-group">
                                <label>Confirm Password <span class="text-danger">*</span></label>
                                <input class="form-control" type="password" formControlName="password_confirmation" placeholder="Confirm new password">
                                <div *ngIf="updatePasswordForm.get('password_confirmation')?.hasError('required') && updatePasswordForm.get('password_confirmation')?.touched" class="text-danger text-small ps-3 mt-0">
                                    Please confirm your password
                                </div>
                                <div *ngIf="updatePasswordForm.hasError('mismatch')" class="text-danger text-small ps-3 mt-0">
                                    Passwords do not match
                                </div>
                            </div>
                        </div>

                        <div class="col-12 text-center mt-4 mb-5">
                            <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Update Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <!-- Step 4: Success Message -->
            <div class="scetion-title text-center" *ngIf="currentStep === 4">
                <div class="success-animation mt-5">
                    <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg>
                </div>
                <h2>Password Changed!</h2>
                <p class="recover-text">Your password has been updated successfully.</p>
                <p class="mb-5">You'll be redirected to home page shortly...</p>
            </div>
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>